<template>
  <div class="center">
    <!-- banner轮播 -->
    <div class="swiper-container" id="mySwiper" ref="Node">
      <div class="swiper-wrapper">
        <div class="swiper-slide" id="ani1">
          <img src="https://cyvideo.i-oranges.com/home/banner.jpg" alt=""/>
          <ParticleSystem03></ParticleSystem03>
        </div>
        <div class="swiper-slide">
          <img src="https://cyvideo.i-oranges.com/home/banner1.jpg" alt=""/>
<!--          <div class="rotate">-->
<!--            <img src="https://cyvideo.i-oranges.com/home/14.png" class="img1" alt="">、-->
<!--            <div class="Particle">-->
<!--              <ParticleSystem02></ParticleSystem02>-->
<!--            </div>-->
<!--            <div class="info Center">-->
<!--              <img src="https://cyvideo.i-oranges.com/home/15.png" class="img1" alt="">-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="swiper-slide">
          <img src="https://cyvideo.i-oranges.com/home/banner2.jpg" alt=""/>
<!--          <ParticleSystem04></ParticleSystem04>-->
        </div>
      </div>
      <!-- 分页器 -->
      <div class="swiper-pagination" style="z-index: 2 !important;"></div>
      <!-- 导航按钮 -->
<!--      <div class="swiper-button-prev"></div>-->
<!--      <div class="swiper-button-next"></div>-->
    </div>
    <ParticleSystem></ParticleSystem>
  </div>
</template>


<script>
import Swiper from 'swiper';
import ParticleSystem from './ParticleSystem01'
import ParticleSystem02 from './ParticleSystem02'
import ParticleSystem03 from './ParticleSystem03'
import ParticleSystem04 from './ParticleSystem04'
export default {
  components: {
    ParticleSystem,
    ParticleSystem02,
    ParticleSystem03,
    ParticleSystem04
  },
  data() {
    return {
      banners: [
        {  imgUrl:'https://cyvideo.i-oranges.com/home/banner.jpg'},
        { imgUrl: 'https://cyvideo.i-oranges.com/home/banner.jpg' },
        { imgUrl: 'https://cyvideo.i-oranges.com/home/banner.jpg' },
      ], // 轮播图数据
      mySwiper: null, // 用于保存Swiper实例

    };
  },
  mounted() {
    // 模拟从后端获取数据
    this.fetchData();
  },

  methods: {
    fetchData() {
      // 模拟异步请求
      setTimeout(() => {
        this.banners= [
          {  imgUrl: 'https://cyvideo.i-oranges.com/home/banner.jpg'},
          { imgUrl: 'https://cyvideo.i-oranges.com/home/banner.jpg' },
          { imgUrl:'https://cyvideo.i-oranges.com/home/banner.jpg' },
        ]// 轮播图数据
      }, 1000);
    },
    initSwiper() {
      if (this.mySwiper) {
        this.mySwiper.destroy(); // 销毁旧的Swiper实例
      }
      this.mySwiper = new Swiper('#mySwiper', {
        loop: true, // 循环模式
        pagination: {
          el: '.swiper-pagination', // 分页器
          clickable: true,
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        effect:"fade",
        speed:1000,
        navigation: {
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev', // 上一页按钮
        },
      });
    },

  },
  watch: {
    banners() {
      // 监听banners数据变化
      this.$nextTick(() => {
        this.initSwiper(); // 初始化Swiper
      });
    },
  },
};
</script>


<style scoped>
.rotate{
  position: absolute;
  width: 34.5%;
  top: 10%;
  z-index: 2;
  left: 32.5%;}
.rotate .img1{width: 100%; position: relative;z-index: 4
}
.rotate .Particle{position: absolute; width: 100%; height: 100%; top:0; z-index: 3;}
.rotate .info{position: absolute; width: 100%; height: 100%; top:0; z-index: 10;}
.rotate .info img{width: 80%; height: auto}
.center {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.center canvas{position: absolute; top:0; height: 100%; width: 100%; z-index: 2}

.swiper-container {
  width: 100%;
  /*height: 400px;*/
}

.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

</style>

<style type="text/css">
.vanta-canvas{ z-index: 2 !important;}
.swiper-pagination-bullet {
  background: #ffffff;
  opacity: 1;
}

.swiper-pagination-bullet-active {
  background: #ff6600;
}
</style>



// WEBPACK FOOTER //
// src/components/SwiperComponents.vue